const STEP_LABELS = {
  'creating-nlp-model': 'Preparing model',
  'cloning-content': 'Copying bot content',
  'translating-strings': 'Translating texts',
  'deploying-channel': 'Connecting channel',
  'linking-items': 'Finalizing',
  'done': 'Finalizing'
}

export function variantStepLabel(status) {
  if (!status || !status.step) return 'Working…'
  const base = STEP_LABELS[status.step] || 'Working…'
  if (status.step === 'translating-strings' && status.progress &&
      status.progress.batch != null && status.progress.totalBatches != null) {
    return `${base} (${status.progress.batch}/${status.progress.totalBatches})`
  }
  return base
}

const delay = ms => new Promise(resolve => setTimeout(resolve, ms))

// fetchStatus: () => Promise<{ status, step, progress, result, error }>
export async function pollVariantJob(fetchStatus, { intervalMs = 2500, initialDelayMs = 0, maxAttempts = 240, maxConsecutiveErrors = 3, onUpdate = () => {} } = {}) {
  if (initialDelayMs > 0) await delay(initialDelayMs)
  let attempts = 0
  let consecutiveErrors = 0
  // eslint-disable-next-line no-constant-condition
  while (true) {
    let status
    try {
      status = await fetchStatus()
      consecutiveErrors = 0
    } catch (fetchErr) {
      consecutiveErrors += 1
      if (consecutiveErrors > maxConsecutiveErrors) throw fetchErr
      await delay(intervalMs)
      continue
    }

    onUpdate(status)
    if (status && status.status === 'completed') return status.result
    if (status && status.status === 'failed') {
      const err = new Error(status.error || 'Variant creation failed')
      err.jobFailed = true
      throw err
    }
    attempts += 1
    if (attempts >= maxAttempts) {
      throw new Error('Timed out waiting for the market to be created. It may still finish — refresh in a moment.')
    }
    await delay(intervalMs)
  }
}
